<template>
  <div class="diaglog-wrapper">
    <div class="dialog-container product-detail-dialog">
      <div class="product-detail-dialog-container">
        <p class="title">{{ letter.storeProductDetail }}</p>
        <div class="info">
          <img class="product-icon" :src="ico" alt="" />
          <p class="product-name">
            {{ name }}
          </p>
        </div>
        <div class="detail">
          <p class="detail-item" v-for="(item, index) in detail" :key="index">
            <img
              class="icon"
              :src="getGamePropIco(item.ICON || 'ico_baoxianxiang.png')"
              @error="handleImgError"
              alt=""
            />
            <span class="text"
              >{{ item.NAME }}<span style="margin-left: 5px">x</span
              >{{ item.AMOUNT || item.COUNT }}</span
            >
          </p>
        </div>
        <div class="btn-wrap" v-if="showBtn" :class="{ center: !canUseCart }">
          <button
            class="select-btn price-btn cart j-click-add-to-cart-detail-popup"
            v-if="canUseCart"
            :pointValue="
              lookDetailItem.PRODUCT_ID + ';' + lookDetailItem.CP_PRODUCT_ID
            "
            @click="addToCart($event, lookDetailItem)"
          >
            {{ letter.add_to_cart }}
          </button>
          <button
            class="select-btn price-btn j-select-product-popup"
            :pointValue="
              lookDetailItem.PRODUCT_ID + ';' + lookDetailItem.CP_PRODUCT_ID
            "
            @click="selectProduct"
          >
            {{ price }}{{ currency }}
          </button>
        </div>
      </div>
      <button class="close-btn point-card-close" @click="close"></button>
    </div>
  </div>
</template>
<script>
import { getProductDefaultImg } from '@utiles/officialStore/productImg'
import { CLOSE_DETAIL_POPUP } from '@store/officialStore/index'
import cartAddAndDetail from '@mixins/officialStore/cartAddAndDetail'
import { mapState } from 'vuex'
export default {
  mixins: [cartAddAndDetail],
  data() {
    return {}
  },
  computed: {
    ...mapState({
      showBtn: state => state.showBtnOfDetailPopup,
      lookDetailItem: state => state.lookDetailItem,
      letter: state => state.letter,
      currency: state => state.showCurrency,
      canUseCart: state => state.cart.canUseCart,
      gameId: state => state.gameId
    }),
    gameInfoConfig() {
      return this.$store.getters.gameInfoConfig
    },
    ico() {
      return (
        this.lookDetailItem.PRODUCT_ICON ||
        gameInfoConfig[this.gameId]['productType'][this.lookDetailItem.itemType]
          .img ||
        ''
      )
    },
    name() {
      return (
        this.lookDetailItem?.CP_PRODUCT_DESC ||
        this.lookDetailItem?.PRODUCT_DESC ||
        ''
      )
    },
    limit() {
      return +this.lookDetailItem.LIMIT
    },
    detail() {
      if (
        this.lookDetailItem.CP_PRODUCT_EXT &&
        this.lookDetailItem.CP_PRODUCT_EXT.CONTENT &&
        Array.isArray(this.lookDetailItem.CP_PRODUCT_EXT.CONTENT) &&
        this.lookDetailItem.CP_PRODUCT_EXT.CONTENT.length
      ) {
        return this.lookDetailItem.CP_PRODUCT_EXT.CONTENT
      }
      return []
    },
    price() {
      return this.lookDetailItem.GAME_AMOUNT || ''
    }
  },
  methods: {
    handleImgError(e) {
      e.target.src = `//abres.octlib.com/commonImg/pnsStore/ico_baoxianxiang.png`
    },
    getGamePropIco(icoName) {
      return `//abres.octlib.com/commonImg/pnsStore/${icoName}${
        /\.(png|jpe?g)$/.test(icoName) ? '' : '.png'
      }`
    },
    close() {
      this.$store.commit(CLOSE_DETAIL_POPUP)
    },
    getProductDefaultIcon(type) {
      return getProductDefaultImg(type)
    },
    selectProduct() {
      this.$emit('selectProduct', this.lookDetailItem)
      this.close()
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@assets/scss/officialStore/_dimen.scss';
.diaglog-wrapper {
  z-index: 1002;
}
.product-detail-dialog {
  padding: 0;
  width: 691px;
  height: 808px;
  background: url($pnsImg + 'detail-popup.png') no-repeat top;
  background-size: cover;
}
.product-detail-dialog-container {
  width: 100%;
  height: 100%;
}
.title {
  margin: 83px auto 32px;
  text-align: center;
  font-weight: bolder;
  font-size: 48px;
  color: #c1a15e;
}
.info {
  display: flex;
  align-items: center;
  margin: 0 auto 26px;
  width: 560px;
  .product-icon {
    width: 80px;
    height: auto;
  }
  .product-name {
    margin-left: 35px;
    line-height: 32px;
    font-weight: normal;
    font-size: 28px;
    color: #e1e1e1;
  }
}
.detail {
  overflow: -moz-scrollbars-none;
  overflow-y: scroll;
  box-sizing: border-box;
  margin: 0 auto;
  padding: 0 32px;
  width: 602px;
  height: 334px;
  background: url($pnsImg + 'detail-bg.png') no-repeat top;
  background-size: cover;
  font-size: 28px;
  color: #e1e1e1;

  -ms-overflow-style: none;
  scrollbar-width: none;
  &-item {
    display: flex;
    align-items: center;
    padding: 30px 0;
    border-bottom: 1px solid #666;
    .icon {
      width: 50px;
    }
    .text {
      padding-left: 33px;
    }
  }
  &::-webkit-scrollbar {
    display: none;
    width: 0 !important;
  }
}
.btn-wrap {
  display: flex;
  justify-content: space-between;
  margin: 58px auto;
  width: 602px;
  &.center {
    justify-content: center;
  }
  .select-btn {
    display: block;
    width: 282px;
    height: 81px;
    background: url($pnsImg + 'confirm.png') no-repeat top;
    background-size: cover;
    line-height: 81px;
    text-align: center;
    font-size: 36px;
    color: #fff;
    &.cart {
      background: url($pnsImg + 'cancel.png') no-repeat top;
    }
  }
}
@media screen and (orientation: landscape) {
  .product-detail-dialog {
    width: 442px;
    height: 516px;
    background: url($pnsImg + 'detail-popup-hen.png') no-repeat top;
  }
  .product-detail-dialog-container {
    width: 100%;
    height: 100%;
  }
  .title {
    margin: 53px auto 20px;
    font-size: 30px;
  }
  .info {
    display: flex;
    margin: 0 auto 17px;
    width: 362px;
    .product-icon {
      width: 50px;
    }
    .product-name {
      margin-left: 24px;
      font-size: 18px;
    }
  }
  .detail {
    padding: 0 32px;
    width: 385px;
    height: 214px;
    background: url($pnsImg + 'detail-bg-hen.png') no-repeat top;
    font-size: 18px;
    &-item {
      padding: 15px 0;
      .icon {
        width: 35px;
      }
      .text {
        padding-left: 20px;
      }
    }
  }
  .btn-wrap {
    margin: 37px auto;
    width: 386px;
    .select-btn {
      display: block;
      width: 181px;
      height: 53px;
      background: url($pnsImg + 'confirm-hen.png') no-repeat top;
      cursor: pointer;
      line-height: 53px;
      font-size: 24px;
      &.cart {
        background: url($pnsImg + 'cancel-hen.png') no-repeat top;
      }
    }
  }
  .close-btn {
    right: 31px;
    top: 23px;
    width: 31px;
    height: 32px;
    background: url($pnsImg + 'close-hen.png') no-repeat top;
    cursor: pointer;
  }
}
</style>
